import React, { Component } from 'react';
import {Link} from "react-router-dom";
import competences from "../../data/competences";
import BrandIcon from "../shared/BrandIcon";

export default class Brand extends Component {

    render(props) {
        return(
            <>
                {/* Start brands Area */}
                <section className="brands-area">
                    <div className="container">
                        <div className="brand-wrap">
                            <div className="row align-items-center active-brand-carusel justify-content-start no-gutters">
                                {
                                    competences.map((value, key) => (
                                      <div className={ `col single-brand single-brand-${value._class}` } key={key}>
                                          <Link to="#"><BrandIcon competence={ value } size="60px" /></Link>
                                      </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </section>
                {/* End brands Area */}
            </>
        )
    }
}